"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPlaceholderOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16,2 C23.7322847,2 30,8.26771525 30,16 C30,23.7322847 23.7322847,30 16,30 C8.26771525,30 2,23.7322847 2,16 C2,8.26771525 8.26771525,2 16,2 Z M16,17.414 L8.25131168,25.1633861 C10.3419313,26.932996 13.0462935,28 16,28 C18.9537065,28 21.6580687,26.932996 23.7486883,25.1633861 L16,17.414 Z M4,16 C4,18.9537065 5.06700396,21.6580687 6.83661388,23.7486883 L14.586,16 L6.83661388,8.25131168 C5.06700396,10.3419313 4,13.0462935 4,16 Z M25.1633861,8.25131168 L17.414,16 L25.1633861,23.7486883 C26.932996,21.6580687 28,18.9537065 28,16 C28,13.0462935 26.932996,10.3419313 25.1633861,8.25131168 Z M16,4 C13.0462935,4 10.3419313,5.06700396 8.25131168,6.83661388 L16,14.586 L23.7486883,6.83661388 C21.6580687,5.06700396 18.9537065,4 16,4 Z" })));
}
exports.default = SvgPlaceholderOutline;
//# sourceMappingURL=PlaceholderOutline.js.map